import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { DISTRIBUTION_POLICIES } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const fundSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Fund),
    isin: z.string().length(12, 'Must be exactly 12 characters long.'),
    currency_id: z.number().int().positive(),
    hedge_currency_id: z.number().int().positive().nullable(),
    country_id: z.number().int().positive(),
    bbg_ticker: z
        .string()
        .min(1)
        .regex(/(\w+)\s{1}(\w+)\s{1}(\w+)/g, `Must have 3 groups of letters exactly. See placeholder for example.`),
    fund_lei: z.string().optional(),
    launch_date: z.iso.date(),
    morning_star_id: z.string().nullable(),
    citi_id: z.string().nullable(),
    lipper_id: z.string().nullable(),
    valor_id: z.string().nullable(),
    mex_id: z.string().nullable(),
    long_name: z.string().min(1),
    shareclass_name: z.string().min(1),
    distribution_policy: z.enum(DISTRIBUTION_POLICIES).optional(),
    issuer: z.string().min(1),
    administrator: z.string().nullable(),
    sedol: z.string().optional(),
});
